import axios from 'axios';

export const configWorkspaceGoogle = (configInfo) =>
  axios.post(
    `${process.env.REACT_APP_GOOGLE_API_URL}/create-new-workspace`,
    configInfo,
  );
